export enum OldStorage {
  ID = "i9MwI8sgkF9d",
  FIRST_NAME = "f9z93v01x69e",
  LAST_NAME = "lx0x8fb1al9e",
  USER_DEMO = "a91psmgw7a9r",
  USER_ROLE = "r9zpgj40xl0e",
  COMPANY_ID = "c0zp2vdupa9y",
  AVATAR_TUTOR = "tutorAvatar",
  TIME_RESULT = "fDzd4LucBkesQe",
  RESULT = "r74cb49Yieqpzt",
  POINTS = "p0zjLb6VZm4Fas",
  RECENTLY_STARTED_COURSE = "recentlyStartedCourse",
}
